var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"dots"},[_vm._l((_vm.d),function(datum,index){return _c('circle',{key:'circle-' + index,class:[
      'dot',
      {
        selected:
          _vm.p.tooltipMove &&
          _vm.p.tooltipMove.datum &&
          _vm.p.tooltipMove.datum[_vm.c.xAxis] == datum[_vm.c.xAxis],
      } ],style:({ fill: _vm.serie.dotColor }),attrs:{"cx":_vm.p.scaleX(datum[_vm.c.xAxis]),"cy":_vm.p.scaleY(datum[_vm.serie.key]),"r":_vm.serie.dotSize}})}),_vm._l((_vm.d),function(datum,index){return _c('text',{key:index,class:[
      'label',
      {
        selected:
          _vm.p.tooltipMove &&
          _vm.p.tooltipMove.datum &&
          _vm.p.tooltipMove.datum[_vm.c.xAxis] == datum[_vm.c.xAxis],
        hidden: _vm.checkTextVisibility(_vm.d, datum, index) || index % 2,
      } ],style:({ fontSize: _vm.serie.fontSize }),attrs:{"x":_vm.p.scaleX(datum[_vm.c.xAxis]),"y":_vm.p.scaleY(datum[_vm.serie.key]),"dy":-18,"dx":index === _vm.d.length - 1 ? -10 : index === 0 ? 10 : 0,"fontSize":_vm.serie.fontSize}},[_vm._v(" "+_vm._s(_vm.p.format(datum[_vm.serie.key]))+_vm._s(_vm.c.globalUnitSymbol)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }